import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import FilterSelect from "components/Form/filterSelect";
import { toast, Bounce } from "react-toastify";

import { useSelector } from "react-redux";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Button } from "components/Button";
import { format } from "date-fns";
import { Modal, Steps, Switch } from "antd";
import { createResginationApi, updateResginationApi } from "../../api/services/resignations";
import EssFullWidthModal from "components/modelpopup/baseModal";
import { customStyleSelect, formatDateHandler, formatDateHandler2, toTitleCase } from "utils/common";
import { MdPending } from "react-icons/md";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { resignationStatusOptions } from "utils/constants";
import useUploadHook from "components/uploadHook";
import { useDropzone } from 'react-dropzone';
import ViewResignationAttachment from "views/pages/Resignation/resignationDetail/attachmentHandler";


const AllResignationAddPopup = ({
  resignationModal,
  setResignationModal,
  loading,
  selectedResignation,
  setLoading,
  setSelectedResignation,
  getResignationList,
  }) => {


const [selectedLastWorkingDay, setSelectedLastWorkingDay] = useState(null);
const [userOption, setUserOption] = useState([]);
const {user,userLoading} = useSelector((state) => state.user);
const {userData, userDataLoading} = useSelector((state) => state.common);
const [defaultUser, setDefaultUser] = useState(null);
const [statusOptions, setStatusOptions] = useState([]);
const [isDisableStatusOption, setIsDisableStatusOption] = useState(false);
  const [currentStatusStep, setCurrentStatusStep] = useState(0);
  const [statusSteps, setStatusSteps] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("")
  const { uploadLoading, handleFile } = useUploadHook();

 

const resignRequestSchema = Yup.object().shape({
    reason: Yup.string().required("Reason is required"),
    last_working_day: Yup.string().required("Last Working Date is required"),
    company_user: Yup.object().required("User is required"),
    attachments: Yup.array()
    .of(
      Yup.object().shape({
        url: Yup.string()
          .url('Invalid URL')
          .required('URL is required'), // Validate URL field
      })
    )
    .test('attachment-count', 'The number of attachments should be at least ${attachment_count} attachments.', function (value) {
      const { attachment_count } = this.parent.document_type || {}; // Access the attachment_count from document_type
      if (attachment_count && value?.length < attachment_count) {
        return this.createError({
          message: `The number of attachments should be at least ${attachment_count} attachments.`,
        });
      }
      return true; // Validation passes
    }),
  });


const resignationApprovalSchema = Yup.object().shape({
    action: Yup.object().required('Status is required'), 
    comment: Yup.string() })

const {
    control,
    handleSubmit,
    formState: { errors },
    getValues,   
    watch,
    setValue,
    setError,
    reset,
    register,
  } = useForm({
    resolver: yupResolver(resignRequestSchema),
    defaultValues: {
      reason: "",
      last_working_day: null,
      company_user: null,
    },  
  });


const {
  control: statusControl,
  handleSubmit: handleStatusSubmit,
  formState: { errors: statusError },
  setValue: setStatusValue,
  getValues: getStatusValue,
  reset  : statusReset,
  setError: setStatusError
} = useForm({
  resolver: yupResolver(resignationApprovalSchema), 
  defaultValues: {
    
  },
});

const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
  control, // control props comes from useForm (optional: if you are using FormProvider)
  name: "attachments", // unique name for your Field Array
});



const status = watch('status')

useEffect(() => {
    if (userData) {
      let users = userData.map((item) => {
        return {
          label: `${item.first_name} ${item.last_name}`,
          value: item.id,
        };
      });
      
      setUserOption(users);
      let defaultUserSelected = userData.find(useritem => useritem.id === user?.id) || null;    
      setDefaultUser(defaultUserSelected);

    
    }
  }, [userData]);


  useEffect(()=>{
    setValue("attachments", selectedResignation?.attachments?.map(item=> {
      return {
        // id: item.id,
        item_id:item.id,
        url: item.url
      }
    }))
  }, [selectedResignation])
  const createApprovalSteps = () => {
    let generated_steps = []
    console.log(selectedResignation, "-----selectedResignation")

    let current_step = selectedResignation?.approval_level
    let existing_steps = selectedResignation?.resignation_approval
    
    if(selectedResignation?.approval_status == "cancelled"){
      generated_steps.push({
        title: 'Request',
        subTitle: "Cancelled",
        description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`Requested on ${formatDateHandler2(selectedResignation?.created_at)} by ${selectedResignation?.company_user?.first_name} ${selectedResignation?.company_user?.last_name} ${selectedResignation?.comment ? " | Comment : " + selectedResignation?.comment : ""}`}</span>,
        icon: <FaTimesCircle  color="red" size={35} />
      })

    }else{
      generated_steps.push({
        title: 'Request',
        subTitle: "Created",
        description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`LWD ${formatDateHandler2(selectedResignation?.last_working_day)}  requested by ${selectedResignation?.company_user?.first_name} ${selectedResignation?.company_user?.last_name} ${selectedResignation?.reason ? " | Reason : " + selectedResignation?.reason : ''}`}</span>,
        icon: <FaCheckCircle  color="green" size={35} />
      })
    }
   
    existing_steps.forEach(item=> {   
      generated_steps.push({
        title: 'Approval',
        subTitle: toTitleCase(item?.status),
        description:<span className="text-wrap lh-1" style={{fontSize:9}} >{`${item?.status=="pending"? item.approver?.first_name+" "+ item.approver?.last_name : toTitleCase(item.status)+" on "+ formatDateHandler2(item?.approved_on) +" by "+item.approver?.first_name+" "+ item.approver?.last_name}  ${item?.comment ? "| Comment : " + item?.comment : ''}`}</span>,
        icon:item?.status=="pending" ?<MdPending   size={35} /> : item?.status=="rejected" ? <FaTimesCircle  color="red" size={35} /> : <FaCheckCircle  color="green" size={35} />
      })
    })
    setCurrentStatusStep(current_step)
    setStatusSteps(generated_steps)   
  }


useEffect(() => {
    if (selectedResignation?.id) {
      const values = getValues();
      const fieldNames = Object.keys(values);
      console.log("Field Names:", fieldNames); 
     fieldNames.forEach(item=>{   
      if(item == "company_user"){
        const selected = userData.find(item=> item.id == selectedResignation?.company_user?.id)
        console.log(selectedResignation?.company_user?.id, "---selected")
        if (selected) {
          setValue(item, {
            label: `${selected.first_name} ${selected.last_name}`,
            value: selected.id,
          });
        }
      //  setValue(item, selected)
      } 
    
    //  
    })  

  
    console.log(user.id,selectedResignation.company_user?.id, "--------fieldNamesStatus")
    if(selectedResignation){
      setCurrentStatus(selectedResignation?.approval_status?.toUpperCase())

    if(user.id === selectedResignation.company_user?.id && selectedResignation?.approval_status==="pending"){
      console.log("Condition 1")
       setStatusOptions(resignationStatusOptions.filter(item=> item.value === "cancel"))
       setIsDisableStatusOption(false)
      console.log("this is condition for self resignation - provide only cancel option")
    } else {
      if(user.id === selectedResignation.current_approver?.id && selectedResignation?.approval_status==="pending"){
        setStatusOptions(resignationStatusOptions.filter(item=> item.value === "approve" || item.value === "reject"))
        // setCurrentStatus(selectedResignation?.resignation_approval[getApproverIndex()].status?.toUpperCase())
  
      }

    }
    console.log(statusOptions, "statusOptions")

   // if(user.id == selectedResignation.current_approver?.id && selectedResignation?.approval_status=="pending"){
     
     // setStatusOptions(resignationStatusOptions.filter(item=> item.value != "cancel"))
  //   console.log("-----set status option 2>>>>>>", resignationStatusOptions.filter(item=> item.value != "cancel"))
   // }

    }

    createApprovalSteps()
    } else {       
       setSelectedResignation("")       
       reset()
       const values = getValues();
       const fieldNames = Object.keys(values);
       console.log("Field Names Apply Screennnn:", fieldNames); 
      fieldNames.forEach(item=>{   
       if(item == "company_user"){
         const selected = userData.find(item=> item.id == user?.id)
         console.log(selected, "---selected in apply resignation")
         if (selected) {
           setValue(item, {
             label: `${selected.first_name} ${selected.last_name}`,
             value: selected.id,
           });
         }      
       } else  if(item == "last_working_day"){
       
        setValue(item, formatDateHandler(new Date()))
       }
      })
    }
    
  }, [selectedResignation, resignationModal, userOption]);


  const onStatusChange = (data) => {
    setLoading(true);
    console.log("---data-------", data)
    const updateData = {
      action: data?.action?.value || "", 
      comment: data?.comment || "", 
      company_user: selectedResignation?.company_user?.id || "", 
      attachments:data.attachments
    };
  
    console.log("Updating resignation status with:", updateData);
  
    updateResginationApi(selectedResignation?.id, updateData)
      .then((response) => {
        setLoading(false);
  
        toast.success("Resignation status updated!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
  
        setResignationModal(false);
        setSelectedResignation("");
        reset();
        getResignationList();
      })
      .catch((e) => {
        console.log(e, "Error updating resignation");
  
        setLoading(false);
  
        let errorMessage = e.response?.data?.error || "Error updating resignation status!";
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
  
        // Handle field-specific validation errors
        if (e.response?.data) {
          Object.entries(e.response.data).forEach(([field, message]) => {
            setStatusError(field, {
              type: "manual",
              message: message
            });
          });
        }
      });
  };

  const fileUploadHandler = async(acceptedFiles , rejectedFiles , e ) => {
    console.log(e.target.files, "EEEE")
    let attachments = []
    const urls = await handleFile(e);
    if(Array.isArray(urls)){
       attachments = urls.map(item=>{return{url: item}})
    }else{
      attachments.push({
        url:urls
      })
    }
    console.log(fields, "LLLL")

    setValue("attachments", [...fields,...attachments])
   }


   // Use Dropzone hook
   const { getRootProps, getInputProps } = useDropzone({
    onDrop: fileUploadHandler,
   
    accept: 'image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document', // Accept image, PDF, DOCX
  });
  

  const onSubmit = (fd) => {
   console.log(fd, "Submitttt DDDD", selectedResignation, "----selectedResignation")
    let data = {...fd}
    console.log(data, "-----fd")

 

    data["company_user"] = data?.company_user?.value;

    if(data.last_working_day){
         data['last_working_day'] = format(new Date(data.last_working_day), "yyyy-MM-dd")
    }
    let attachments_data = data?.attachments?.map(item=>{
      return{
        id: item.item_id||"",
        url: item.url
      }
    })
    data['attachments'] = attachments_data

   
    setLoading(true);

    if(selectedResignation?.id){
      updateResginationApi(selectedResignation?.id, data).then(response=>{
        setLoading(false)

        toast.success('Resignation updated!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setResignationModal(false)
          setSelectedResignation("")
          reset({
            document_type: null,
            attachments: []
          })

        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)

        try{
          console.log(e.response.data, "EEEEE")
          if(e.response.data){
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, "EEEEE")
              setError(k,
                {
                  type: 'manual',
                  message: v.join(", ")
                }
                 )
            })
          }
        }catch(e){
          let commonError = e.response?.data?.error || 'Failed to update Resignation!'

          toast.error(commonError, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }

      })

    }else{
      console.log(data, "-----data")
     
      createResginationApi(data).then(response=>{
        setLoading(false)

        toast.success('Resignation created!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          setResignationModal(false)
          setSelectedResignation("")
          reset({     document_type: null,
            attachments: []
          })
          getResignationList()

        console.log(response, "REEEEEE")
      }).catch(e=> {
        setLoading(false)

        try{
          console.log(e.response.data, "EEEEE")
          if(e.response.data){
            Object.entries(e.response.data).forEach(([k, v]) => {
              console.log(typeof v, "EEEEE")
              setError(k,
                {
                  type: 'manual',
                  message: v.join(", ")
                }
                 )
            })
          }
        }catch(e){
          console.log(e, "----ee")
          let commonError = e.response?.data?.error || 'Failed to create new data!'
          toast.error(commonError, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }

      })
    }
  };

  const getApproverIndex = () => {
    let index = -1;
    if(selectedResignation) {
      index = selectedResignation.resignation_approval.findIndex(
        approval => approval.approver.id === user.id && approval.approver.emp_no === user.emp_no
     );
    }
    return index
 
  }



  return (
    <>
      <div role="dialog">
        <EssFullWidthModal
          mask={false}
          title={selectedResignation?.id ? "Change Resignation Status" : "Apply Resignation"}
          // style={{ top: 100 }}
          open={resignationModal}
          width={"40%"}
          footer={[]}
          onCancel={() => {
            setResignationModal(false);
            setSelectedResignation("");
            setStatusOptions([])
            reset()
          }}
          className="full-width-modal"
        >
          <div className="modal-content">
            <div className="modal-body">

            {selectedResignation?.id ? 
            <form onSubmit={handleStatusSubmit(onStatusChange)}>

              
            {  selectedResignation?.id &&
              <div className="row" >
                
                <div className="col-md-12 col-sm-12" >
                  <div className="card p-3" >
                  <label className="col-form-label">
                    Approval status
                  </label>

                  <Steps
                  current={currentStatusStep}
                  // percent={60}
                  items={statusSteps}
                />
                  </div>
               
                </div>
              </div>
            }

              <div className="row"> 
              
                {/* Select User */}
                <div className="col-md-6">
                  <div className="input-block mb-3">
                    <label className="col-form-label">User</label>
                    <input
                    className="form-control"
                    readOnly
                    value={`${selectedResignation.company_user?.first_name} ${selectedResignation?.company_user?.last_name}`}

                    defaultValue={`${selectedResignation?.company_user?.first_name} ${selectedResignation?.company_user?.last_name}`}
                    type="text"
                  />                  
                  </div>
                </div>
                
                {/* LWD */}
                <div className="input-block mb-3 col-md-6 col-sm-12">
                  <label className="col-form-label">
                    Last Working Date 
                  </label>
                  <div className="cal-icon">                 
                    <DatePicker
                            className="form-control floating datetimepicker "
                            disabled
                            selected={selectedResignation?.last_working_day}                            
                            dateFormat="dd-MM-yyyy"                          
                    />  
                  </div>
                </div>
              </div>


              <div className="row">             

                {/* Reason */}

                <div className="input-block mb-3 col-md-6 col-sm-12">
                                  <label className="col-form-label">
                                    Reason
                                  </label>
                                  <textarea
                            rows={4}
                            readOnly
                            className="form-control"
                            value={selectedResignation?.reason}
                            // onChange={field?.onChange}
                          />
                </div>

                 <div className="input-block mb-3  col-md-6 col-sm-12">
                    <label className="col-form-label">
                      Current status
                    </label>
                    <input className="form-control" readOnly type="text" value={currentStatus} />
                  </div> 


           

              </div>

              <div className="row" >
                   
               <div className="input-block mb-3 col-md-6 col-sm-12">
                {
                  console.log(statusOptions, "statusOptions")
                }
               {
                 statusOptions.length > 0 && 
                 <>
                   <label className="col-form-label">
                     Change Status <span className="text-danger">*</span>
                   </label>
                   <Controller
                     name="action"
                     control={statusControl}
                     render={({ field }) => (
                       <div className="d-flex align-items-center">
                         {
                           statusOptions.length > 0 && statusOptions.some(option => option.value === "approve" || option.value === "reject") && (
                             <>
                               <div className="form-check me-4 d-flex align-items-end">
                                 <input
                                   style={{width: 20, height: 20}}
                                   className={`form-check-input ${field.value?.value === "approve" ? "bg-success border-success" : ""}`}
                                   type="checkbox"
                                   id="status-approved"
                                   disabled={statusOptions.length === 0}
                                   checked={field.value?.value === "approve"}
                                   onChange={() => {
                                     field.onChange({ label: "Approve", value: "approve" });
                                   }}
                                 />
                                 <label className="form-check-label ms-2" htmlFor="status-approved">
                                   Accept Approval
                                 </label>
                               </div>
                               <div className="form-check me-4 d-flex align-items-end">
                                 <input
                                   style={{width: 20, height: 20}}
                                   className={`form-check-input ${field.value?.value === "reject" ? "bg-danger border-danger" : ""}`}
                                   type="checkbox"
                                   id="status-rejected"
                                   disabled={statusOptions.length === 0}
                                   checked={field.value?.value === "reject"}
                                   onChange={() => {
                                     field.onChange({ label: "Reject", value: "reject" });
                                   }}
                                 />
                                 <label className="form-check-label ms-2" htmlFor="status-rejected">
                                   Reject Approval
                                 </label>
                               </div>
                             </>
                           )
                         }
                         
                         {statusOptions.length > 0 && statusOptions.some(option => option.value === "cancel") && (
                           <div className="form-check d-flex align-items-end">
                             <input
                               style={{width: 20, height: 20}}
                               className={`form-check-input ${field.value?.value === "cancel" ? "bg-danger border-danger" : ""}`}
                               type="checkbox"
                               id="status-cancelled"
                               checked={field.value?.value === "cancel"}
                               onChange={() => {
                                 if(field.value?.value === "cancel") {
                                   field.onChange({ label: "", value: "" });
                                 } else {
                                   field.onChange({ label: "Cancel", value: "cancel" });
                                 }
                               }}
                             />
                             <label className="form-check-label ms-2" htmlFor="status-cancelled">
                               Cancel
                             </label>
                           </div>
                         )}
                       </div>
                     )}
                   />
                   {statusError.action && (
                     <small className="text-danger">
                       {statusError.action?.message}
                     </small>
                   )}
                   <br/>
                 </>
               }

                <label className="col-form-label ">
                    Comment 
                  </label>
                  <Controller
                          name="comment"
                          control={statusControl}
                          // rules={{ required: 'File name is required' }}
                          render={({ field }) => (
                            <textarea
                            disabled={statusOptions.length == 0}
                            rows={4}
                            className="form-control"
                            value={field?.value}
                            onChange={field?.onChange}
                          />
                          
                          )}
                        />
                  {statusError.comment && (
                        <small className="text-danger">
                          {statusError.comment?.message}
                        </small>
                      )}
               </div>
              </div>

              

               {/* Attachments */}
             
               <div className="row">
                  <div className="col-md-6">
                  <div className="input-block mb-3">

                  <label className="col-form-label">Attachments {
                    uploadLoading && <i class="fa fa-spinner fa-spin" ></i>
                  }</label>
                    
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

                  {/* <input
                    type="file"
                    className="form-control"
                    id="cv_upload"
                    // accept=".png, .jpg, .jpeg"
                    onChange={fileUploadHandler}
                    disabled={uploadLoading}
                    multiple
                  /> */}
                  <p className="text-danger mb-2">
                    {errors?.attachments?.message}
                  </p>
                  
                </div>

             


                  </div>

                    {/* {
                      selectedResignation?.id &&
                      <div className="col-md-6">
                  <div className="input-block mb-3">
                  <label className="col-form-label">Status</label>

                  <Controller
                          name="status"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="d-flex align-items-center">
                              <Switch 
                                checked={value} 
                                onChange={onChange} 
                                onColor="#0d6efd" 
                                offColor="#ccc"
                                // checkedIcon={<div style={{ padding: 5 }}>Active</div>}
                                // uncheckedIcon={<div style={{ padding: 5 }}>Inactive</div>}
                              />
                            </div>
                          )}
                        />

                    {console.log(errors, "EEEEEEEE")}
                    {errors.status && (
                      <small className="text-danger">
                        {errors.status?.message}
                      </small>
                    )}
                  </div>
                  </div>
                    }
                   */}

   


                  
                </div>

                <div className="row">
              <div className="col-12" >
                <ViewResignationAttachment disabled={selectedResignation?.id} fields={fields} remove={remove}  />

                </div>
                </div>
                
              <div className="submit-section">
                <Button
                  loading={loading}
                  disabled={loading}
                  className="btn btn-primary submit-btn"
                  type="submit"
                  label="Submit"
               
                />
              </div>
            </form>

              : <form onSubmit={handleSubmit(onSubmit)}>

              
              {  selectedResignation?.id &&
                <div className="row" >
                  
                  <div className="col-md-12 col-sm-12" >
                    <div className="card p-3" >
                    <label className="col-form-label">
                      Approval status
                    </label>

                    <Steps
                    current={currentStatusStep}
                    // percent={60}
                    items={statusSteps}
                  />
                    </div>
                 
                  </div>
                </div>
              }

                <div className="row"> 
                
                  {/* Select User */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">User</label>
                      <Controller
                        name={`company_user`}
                        control={control}
                      
                        render={({ field: { value, onChange } }) => (
                          <>
                            <FilterSelect
                              {...register("company_user")}
                              isClearable={true}
                              onChange={onChange}
                              optionLabel={"label"}
                              optionValue={"value"}
                              defaultValue={userOption[0]} 
                              options={userOption}
                              isDisabled={true}
                              isLoading={userDataLoading}
                              value={value}
                              placeholder={"Company user"}
                            
                            />
                          </>
                        )}
                      />
                      {console.log(errors, "EEEEEEEE")}
                      {errors.company_user && (
                        <small className="text-danger">
                          {errors.company_user?.message}
                        </small>
                      )}
                    </div>
                  </div>
                  
                  {/* LWD */}
                  <div className="col-md-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Last Working Day*</label>
                      <Controller
                        name="last_working_day"
                        control={control}
                        defaultValue={null} 
                        render={({ field }) => (
                          <DatePicker
                            className="form-control floating datetimepicker "
                            selected={field?.value}
                            onChange={field.onChange}
                            dateFormat="dd-MM-yyyy"
                          />
                        )}
                      />
                      {errors.last_working_day && (
                        <small className="text-danger">
                          {errors.last_working_day?.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                

                  {/* Reason */}

                  <div className="input-block mb-3 col-md-6 col-sm-12">
                                    <label className="col-form-label">
                                      Reason <span className="text-danger">*</span>
                                    </label>
                                    <Controller
                                            name="reason"
                                            control={control}
                                            // rules={{ required: 'File name is required' }}
                                            render={({ field }) => (
                                              <textarea
                                              rows={4}
                                              className="form-control"
                                              value={field?.value}
                                              onChange={field?.onChange}
                                            />
                                            
                                            )}
                                          />
                                    {errors.reason && (
                                          <small className="text-danger">
                                            {errors.reason?.message}
                                          </small>
                                        )}
                                  </div>


             

                </div>


   {/* Attachments */}
             
   <div className="row">
                  <div className="col-md-6">
                  <div className="input-block mb-3">

                  <label className="col-form-label">Attachments {
                    uploadLoading && <i class="fa fa-spinner fa-spin" ></i>
                  }</label>
                    
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      style={{
                        border: '2px dashed #000',
                        padding: '20px',
                        textAlign: 'center',
                      }}
                    >
                      <input {...getInputProps()} />
                      <p>Drag & Drop your files here, or click to select files</p>
                    </div>

                  {/* <input
                    type="file"
                    className="form-control"
                    id="cv_upload"
                    // accept=".png, .jpg, .jpeg"
                    onChange={fileUploadHandler}
                    disabled={uploadLoading}
                    multiple
                  /> */}
                  <p className="text-danger mb-2">
                    {errors?.attachments?.message}
                  </p>
                  
                </div>

             


                  </div>

                    {
                      selectedResignation?.id &&
                      <div className="col-md-6">
                  <div className="input-block mb-3">
                  <label className="col-form-label">Status</label>

                  <Controller
                          name="status"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="d-flex align-items-center">
                              <Switch 
                                checked={value} 
                                onChange={onChange} 
                                onColor="#0d6efd" 
                                offColor="#ccc"
                                // checkedIcon={<div style={{ padding: 5 }}>Active</div>}
                                // uncheckedIcon={<div style={{ padding: 5 }}>Inactive</div>}
                              />
                              {/* <span className="ms-2">{value ? "Active" : "Inactive"}</span> */}
                            </div>
                          )}
                        />

                    {console.log(errors, "EEEEEEEE")}
                    {errors.status && (
                      <small className="text-danger">
                        {errors.status?.message}
                      </small>
                    )}
                  </div>
                  </div>
                    }
                  

   


                  
                </div>

                <div className="row">
              <div className="col-12" >
                <ViewResignationAttachment fields={fields} remove={remove}  />

                </div>
                </div>
            
                <div className="submit-section">
                  <Button
                    loading={loading}
                    disabled={loading}
                    className="btn btn-primary submit-btn"
                    type="submit"
                    label="Submit"
                 
                  />
                </div>
              </form>
            }
            </div>
          </div>
        </EssFullWidthModal>
      </div>
    </>
  );
};

export default AllResignationAddPopup;
